window.igloo.add_zone(['{{QUERY_CONFIG}}', '{{AD_TAGS}}', '{{PRODUCT_CONFIG}}', '{{BASE_TIMING}}']);
